<template>
  <div class="c-table-cell">
    <div class="c-table-cell__wrapper cell-employee">
      <c-button
        v-if="canEdit"
        v-b-popover.html="{
          container: '#app',
          trigger: 'hover blur',
          content: 'Удалить из расчета',
          placement: 'bottom',
        }"
        class="cell-employee__remove"
        size="iconic"
        icon="close"
        @click="$emit('productionRemoveWorkerFromCalc', record)"
      />

      <router-link
        target="_blank"
        :to="{ name: 'personal-employee-summary', params: { id: record.id } }"
        class="cell-employee__name"
      >
        {{ record.employee.value }}
      </router-link>

      <div class="cell-employee__info">
        <router-link
          v-if="record.doc_problem.length > 0"
          target="_blank"
          :to="{ name: 'personal-employee-summary', params: { id: record.id } }"
          class="cell-employee__docs-trouble"
        >
          <svg
            v-b-popover.html="{
              container: '#app',
              trigger: 'hover blur',
              content: record.doc_problem,
              placement: 'top',
            }"
            width="10"
            height="13"
            viewBox="0 0 10 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.96875 1H1V12H9V3.03125M6.96875 1L9 3.03125M6.96875 1V3.03125H9M3 6C3 6 5.4379 6 7 6M3 9.03125C3 9.03125 5.4379 9.03125 7 9.03125"
              stroke="#FF238D"
              stroke-width="2"
            />
          </svg>

          <!--          <div class="cell-employee__docs-trouble-tooltip">-->
          <!--            {{ record.doc_problem }}-->
          <!--          </div>-->
        </router-link>

        <div
          v-if="false && record.codeGroup === 'driver' && (true || record.dismissed)"
          :to="{ name: 'personal-employee-summary', params: { id: record.id } }"
          class="cell-employee__fired"
        >
          <svg
            v-b-popover.html="{
              container: '#app',
              trigger: 'hover blur',
              content: `На дату расчета ${calculationDate}<br>статус водителя <b>${record.working_status}</b>`,
              placement: 'top',
            }"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 9C5.55228 9 6 8.55228 6 8C6 7.44772 5.55228 7 5 7V9ZM3.49264 8V7V8ZM1 10.6478H0H1ZM0 11C0 11.5523 0.447715 12 1 12C1.55228 12 2 11.5523 2 11H0ZM11.7071 8.70711C12.0976 8.31658 12.0976 7.68342 11.7071 7.29289C11.3166 6.90237 10.6834 6.90237 10.2929 7.29289L11.7071 8.70711ZM7.29289 10.2929C6.90237 10.6834 6.90237 11.3166 7.29289 11.7071C7.68342 12.0976 8.31658 12.0976 8.70711 11.7071L7.29289 10.2929ZM8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L8.70711 7.29289ZM10.2929 11.7071C10.6834 12.0976 11.3166 12.0976 11.7071 11.7071C12.0976 11.3166 12.0976 10.6834 11.7071 10.2929L10.2929 11.7071ZM5 7H3.49264V9H5V7ZM3.49264 7C2.54619 7 1.65165 7.39993 1.00196 8.09006L2.45819 9.46097C2.74342 9.15799 3.11692 9 3.49264 9V7ZM1.00196 8.09006C0.354196 8.77815 0 9.69916 0 10.6478H2C2 10.1919 2.17104 9.766 2.45819 9.46097L1.00196 8.09006ZM0 10.6478V11H2V10.6478H0ZM6.99411 2.98584C6.99411 3.52639 6.55296 3.97168 6 3.97168V5.97168C7.64968 5.97168 8.99411 4.63879 8.99411 2.98584H6.99411ZM6 3.97168C5.44704 3.97168 5.00589 3.52639 5.00589 2.98584H3.00589C3.00589 4.63879 4.35032 5.97168 6 5.97168V3.97168ZM5.00589 2.98584C5.00589 2.44529 5.44704 2 6 2V0C4.35032 0 3.00589 1.33289 3.00589 2.98584H5.00589ZM6 2C6.55296 2 6.99411 2.44529 6.99411 2.98584H8.99411C8.99411 1.33289 7.64968 0 6 0V2ZM10.2929 7.29289L8.79289 8.79289L10.2071 10.2071L11.7071 8.70711L10.2929 7.29289ZM8.79289 8.79289L7.29289 10.2929L8.70711 11.7071L10.2071 10.2071L8.79289 8.79289ZM7.29289 8.70711L8.79289 10.2071L10.2071 8.79289L8.70711 7.29289L7.29289 8.70711ZM8.79289 10.2071L10.2929 11.7071L11.7071 10.2929L10.2071 8.79289L8.79289 10.2071Z"
              fill="#FF238D"
            />
          </svg>
        </div>

        <div
          v-if="record.recommened_category !== 0"
          class="cell-employee__rank-status"
          :class="`cell-employee__rank-status_${record.recommened_category === 1 ? 'up' : 'down'}`"
        >
          <svg
            v-b-popover.html="{
              container: '#app',
              trigger: 'hover blur',
              content: hiringRecommendation,
              placement: 'top',
            }"
            width="10"
            height="12"
            viewBox="0 0 10 12"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M5 1V11M5 11L9 7M5 11L1 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/controls/button";

export default {
  name: "production-cell-employee",
  components: {
    "c-button": Button,
  },
  props: ["record", "calculationData", "canEdit"],

  data() {
    return {
      baseUrl: window.location.origin,
    };
  },

  computed: {
    calculationDate() {
      const data = (this.calculationData && this.calculationData.calc && this.calculationData.calc.calculation) || {};
      return data.date;
    },
    hiringRecommendation() {
      if (this.record.recommened_category === 1) {
        return "Рекомендуем повысить разряд";
      }
      if (this.record.recommened_category === -1) {
        return "Рекомендуем понизить разряд";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-table-cell {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  line-height: 13px;

  .cell-employee {
    padding: 10px;
    display: flex;
    width: 100%;
    //overflow: hidden;
    //justify-content: space-between;
    align-items: center;

    &__remove {
      margin-right: 9px;

      & ::v-deep .c-icon_close {
        margin-top: -5px !important;
        margin-left: -5px !important;
      }

      & ::v-deep .c-button__wrapper {
        width: 22px !important;
        height: 22px !important;
      }
      & ::v-deep svg {
        width: 10px;
        height: 10px;
      }

      & ::v-deep svg path {
        fill: #8e9cbb;
      }
    }

    &__name {
      color: $color-primary;
      text-decoration: none;
      font-size: 13px;
      line-height: 14px;
      margin-right: 10px;
    }

    &__info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      margin-left: auto;
    }

    &__docs-trouble,
    &__rank-status,
    &__fired {
      outline: none;
      position: relative;
      display: flex;
      justify-content: center;
      cursor: pointer;

      &-tooltip {
        position: absolute;
        background: white;
        font-size: 11px;
        box-shadow: $box-shadow-tooltip;
        padding: 6px 10px;
        border-radius: $border-radius-tooltip;
        bottom: 0;
        right: -10px;
        max-width: 200px;
        width: max-content;
        text-align: center;
        line-height: 16px;
        opacity: 0;
        visibility: hidden;
        transition: 0.2s;
        font-weight: 400;
        z-index: 100;
      }

      & svg {
        outline: none;
      }
    }

    &__docs-trouble {
      &:hover {
        .cell-employee__docs-trouble-tooltip {
          visibility: visible;
          opacity: 1;
          bottom: 20px;
        }
      }
    }

    &__docs-trouble ~ .cell-employee__rank-status {
      margin-top: 13px;
    }

    &__docs-trouble ~ .cell-employee__fired {
      margin-top: 10px;
    }

    &__rank-status {
      &_up {
        svg {
          stroke: $color-green;
          transform: rotate(180deg);
        }
      }

      &_down {
        svg {
          stroke: $color-secondary;
        }
      }

      &:hover {
        .cell-employee__rank-status-tooltip {
          visibility: visible;
          opacity: 1;
          bottom: 16px;
        }
      }
    }
  }

  .cell-deposit-state {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 10px;
    font-size: 13px;

    &_none {
      background: $color-bg;
    }

    &_error {
      background: $color-bg-secondary;
    }

    &_success {
      background: $color-bg-success;
    }

    &_warning {
      background: $color-bg-warning;
    }
  }
}
</style>
